export const IMAGE = 'IMAGE'
export const TEXT = 'TEXT'
export const PRODUCT_NAME = 'PRODUCT_NAME'
export const HIDDEN = 'HIDDEN'
export const ADD_SCENE_BUTTON = 'ADD_SCENE_BUTTON'



// WEBPACK FOOTER //
// ./src/constants/sidebarSceneType.js